<template>
    <div>
        <v-dialog max-width="400px" persistent v-model="showChangePasswordModal" @close="close">
            <v-card>
                <v-card-title class="blue-grey lighten-3 white--text">
                    <span class="headline">Alterar Senha</span>
                </v-card-title>

                <v-card-text>
                    <p><b>Funcionário(a): </b>{{selectedUser.name}}</p>
                    <!--Nova Senha-->
                    <v-text-field v-model="selectedUser.newPassword"
                                  :counter="$v.selectedUser.newPassword.$params.maxLength.max"
                                  :error-messages="newPasswordErrors"
                                  @blur="$v.selectedUser.newPassword.$touch()"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:append="showPassword = !showPassword"
                                  @keyup.enter="$v.invalid ? '' : changePassword"
                                  label="Nova senha"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="grey darken-1" flat="flat" @click="showChangePasswordModal = false">
                            Cancelar
                        </v-btn>

                        <v-btn color="blue lighten-2 white--text" :disabled="$v.$invalid" @click="changePassword">
                            Confirmar
                        </v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {maxLength, minLength, required} from 'vuelidate/lib/validators'
    import {eventBus} from "../../main";

    export default {
        name: "ChangePassword",

        data(){
            return{
                showPassword: false,
                loading_modal: false,
            }
        },

        validations:{
            selectedUser: {
                newPassword: {
                    minLength: minLength(6),
                    maxLength: maxLength(40),
                    required,
                },
            }
        },

        computed:{
            ...mapGetters([
                'getNewUser',
            ]),
            showChangePasswordModal: {
                get(){
                    return this.$store.getters.getShowChangePasswordModal;
                },
                set(value){
                    this.$store.dispatch('setShowChangePasswordModal', value);
                }
            },

            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },

            newPasswordErrors(){
                const errors = [];
                if (!this.$v.selectedUser.newPassword.$dirty) return errors;
                !this.$v.selectedUser.newPassword.minLength && errors.push('Mínimo de 6 caracteres');
                !this.$v.selectedUser.newPassword.maxLength && errors.push('Máximo de 40 caracteres');
                !this.$v.selectedUser.newPassword.required && errors.push('Digite a nova senha');
                return errors
            },
        },

        methods: {
            changePassword(){
                try{
                    this.loading_modal = true;
                    Vue.axios.post('user/change_pass/'+this.selectedUser.id, {
                        password: this.selectedUser.newPassword
                    }).then(response=>{
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            eventBus.$emit('onPasswordChanged', response);
                            return;
                        }
                        if(response.data.response === 'notAuthorized'){
                            eventBus.$emit('onPasswordChanged', response);
                            this.loading = false;
                            this.close();
                            return;
                        }

                        this.close();
                        eventBus.$emit('onPasswordChanged', response);
                        this.$emit('changePasswordCallback', true);
                    }).catch(error=>{
                        this.consoleLog(error);
                        eventBus.$emit('onPasswordChanged', null);
                    }).finally(()=>{
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.consoleLog(e);
                    eventBus.$emit('onPasswordChanged', null);
                }
            },

            close () {
                this.$v.$reset();
                this.selectedUser.newPassword = '';

                this.selectedUser = this.getNewUser;
                // this.selectedIndex = -1;
                // this.selectedSell = this.getNewCompany();
                // setTimeout(() => {
                this.showPassword = false;
                this.showChangePasswordModal = false;
                    // this.active_tab = 0;
                    this.loading_modal = false;
                    // this.sellShow = false;
                // }, 10);
            },
        }
    }
</script>

<style scoped>

</style>